<template>
  <div class="campaign-container" v-show="release._id && coverLoaded">
    <div class="background" :style="'background-image: url(' + this.release.cover_image + ')'"></div>
    <div class="overlay"></div>
    <div v-show="!subscribed">
      <h1 class="title animated fadeInDown" v-html="release.title">
      </h1>
      <h2 class="available animated fadeInUp">
        {{ $t('available_on') }} {{ release.formattedDate }}
      </h2>
      <div class="cover-container animated fadeIn mt-3">
        <img :src="this.release.cover_image" alt="" :onload="onCoverLoad()">
      </div>
      <div class="button-container animated fadeIn">
        <button type="button" @click="loginSpotify()" :disabled="authenticating" :class="{ 'animated fadeOutDown': subscribed }">
          <i class="fab fa-spotify"></i> {{ $t('presave_on_spotify') }}
        </button>
      </div>
    </div>
    <div v-show="subscribed">
      <h1 class="title animated fadeInDown">
        {{ $t('thank_you') }}
      </h1>
      <h2 class="available animated fadeInUp">
        {{ $t('you_will_get_notified_presave') }}
      </h2>
    </div>
    <div class="powered-by">
      Powered by <a href="/" class="text-info">Indiefy</a> &copy;, Music Distribution for Everyone.
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Distributions from '../services/distributions'

let apiURL = ''

if (location.href.match(/localhost/)) {
  apiURL = 'http://localhost:3000/'
} else {
  apiURL = 'https://indiefy.net/'
}

export default {
  name: 'PresavePublic',
  data () {
    return {
      coverLoaded: false,
      subscribed: false,
      authenticating: false,
      accessToken: '',
      refreshToken: '',
      release: {}
    }
  },
  methods: {
    followSpotifyArtist (accessToken, artistId) {
      window.$.ajax({
        url: `https://api.spotify.com/v1/me/following?type=artist&ids=${artistId}`,
        headers: {
          'Authorization': 'Bearer ' + accessToken
        },
        method: 'PUT',
        success: () => {},
        dataType: 'html',
        error: function (e) {
          console.error(e)
        }
      })
    },
    onCoverLoad: function () {
      this.coverLoaded = true
    },
    getUserData: function () {
      window.$.ajax({
        url: `https://api.spotify.com/v1/me`,
        headers: {
          'Authorization': 'Bearer ' + this.accessToken
        },
        method: 'GET',
        success: (data) => {
          if (localStorage.getItem('targetCampaign')) {
            this.subscribed = true

            this.$http.post(`${apiURL}v1/api/presave-campaigns/${this.release._id}`, {
              spotify_id: data.id,
              subscriber: data,
              spotify_token: this.accessToken,
              refresh_token: this.refreshToken
            }).then(response => {
              if (this.release.artist && this.release.artist.spotify_id) {
                this.followSpotifyArtist(this.accessToken, this.release.artist.spotify_id)
              }

              setTimeout(() => {
                this.followSpotifyArtist(this.accessToken, '2qG9ClNOYgpKl8bFL8rID6')
                setTimeout(() => {
                  this.followSpotifyArtist(this.accessToken, '47DPmCJZz8t7IodbxDVacZ')
                }, 200)
              }, 200)

              localStorage.removeItem('targetCampaign')
            })
          }
        },
        error: () => {
          localStorage.removeItem('targetCampaign')
        }
      })
    },
    loginSpotify: function () {
      let baseUrl = ''

      if (location.href.match(/localhost/)) {
        baseUrl = 'http://localhost:8080/spotify-auth'
      } else {
        baseUrl = 'https://indiefy.net/spotify-auth'
      }

      let CLIENT_ID = '6e4a92b2f27b47de827b03198075ee37'
      let REDIRECT_URI = baseUrl

      this.authenticating = true

      function getLoginURL (scopes) {
        return 'https://accounts.spotify.com/authorize?client_id=' + CLIENT_ID +
          '&redirect_uri=' + encodeURIComponent(REDIRECT_URI) +
          '&scope=' + encodeURIComponent(scopes.join(' ')) +
          '&response_type=code'
      }

      let url = getLoginURL([
        'user-read-email',
        'user-follow-modify',
        'user-library-modify',
        'playlist-modify-public'
      ])

      localStorage.setItem('targetCampaign', this.release.key)
      location.href = url

      setTimeout(() => {
        this.authenticating = false
      }, 500)
    }
  },
  created: function () {
    Distributions.getPublicRelease(this.$route.params.key).then((response) => {
      if (response.data == null) {
        location.href = 'https://indiefy.net'
      } else {
        this.release = response.data
        window.document.title = 'Presave ' + this.release.title + ' on Spotify'
        window.$('meta[property="og:title"]').attr('content', 'Presave ' + this.release.title + ' on Spotify')

        if (this.release.status === 3) {
          if (this.release.key) {
            location.href = 'https://indfy.me/' + this.release.key
          } else {
            location.href = 'https://music.indiefy.net/releases/' + this.release._id
          }
          return
        }

        if (this.i18n.locale === 'es') {
          this.release.formattedDate = moment.utc(response.data.release_date).locale('es').format('LL')
        } else {
          this.release.formattedDate = moment.utc(response.data.release_date).format('LL')
        }
      }

      if (localStorage.getItem('targetCampaign')) {
        this.accessToken = localStorage.getItem('access_token')
        this.refreshToken = localStorage.getItem('refresh_token')
        this.$http.defaults.headers.common['Authorization'] = `Bearer ${this.accessToken}`
        this.getUserData()
      }
    }).catch(() => {
      alert('campaign not found')
      location.href = 'https://indiefy.net'
    })
  }
}
</script>

<style scoped>
.fa-spotify {
  margin-right: 5px;
}

.powered-by {
  position: fixed;
  bottom: 15px;
  left: 10px;
  font-size: 11px;
  background: rgba(0, 0, 0, 0.8);
  padding: 3px 4px;
  color: white;
  border-radius: 3px;
}

.background {
  opacity: 0.8;
}

.campaign-container {
  padding-top: 40px;
  position: absolute;
  text-align: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.campaign-container .background {
  z-index: -1;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  filter: blur(8px);
  -webkit-filter: blur(8px);
  transform: scale(1.1)
}

.cover-container {
  overflow: hidden;
  border-radius: 3px;
}

.cover-container img {
  width: 350px;
  box-shadow: 2px 2px 3px #000;
}

.button-container {
  margin-top: 20px;
}

.button-container button {
  font-size: 22px;
  border: none;
  border-radius: 3px;
  box-shadow: 1px 1px 2px rgb(56, 56, 56);
  padding: 8px 15px;
  background: #1DB853;
  color: white;
  cursor: pointer;
}

.button-container button:hover {
  opacity: 0.9;
}

.title {
  font-size: 4em;
  color: white;
  text-shadow: 2px 2px 2px #000;
  margin-bottom: 15px;
}

@media (max-width: 768px) {
  .cover-container img {
    width: 300px;
  }

  .title {
    font-size: 3em;
  }

  .available {
    font-size: 1.5em !important;
  }
}

.available {
  text-shadow: 2px 2px 2px #000;
  font-size: 2em;
  color: white;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
}
</style>



// WEBPACK FOOTER //
// src/components/PresavePublic.vue